export enum Role {
    Admin = 'admin',
    Mentor = 'mentor',
    Mentee = 'mentee'
}